import { APP_VERSION } from '../version';

export function Footer() {
  const deploymentEnvironment = import.meta.env.VITE_DEPLOYMENT_ENV
    ?.trim()
    .toLowerCase();
  const isProduction = deploymentEnvironment === 'production';

  return (
    <footer>
      <span>HubSpot Phonero Portal</span>
      <span>
        {isProduction
          ? `v${APP_VERSION}`
          : `Development preview of v${APP_VERSION}`}
      </span>
    </footer>
  );
}
